import _cloneDeep from 'lodash/cloneDeep';

export default {
  clientAddressResults: (state) => _cloneDeep(state.clientAddressResults),
};
